import { Label } from "@/components/shadcn/ui/label"
import { DatePickerField } from "@/models/new/forms.types"
import { ResponseValue, DatePickerResponse } from "@/models/new/formResponse.types"
import { DateTimePicker } from "@/components/shadcn/ui/date-time-picker"

interface Props {
  field: DatePickerField
  value?: ResponseValue
  onChange: (fieldId: string, value: ResponseValue) => void
}

const DatePicker = (props: Props) => {
  const { field, value, onChange } = props

  const currentValue =
    value?.type === "datepicker" ? (value as DatePickerResponse).value : undefined

  const handleChange = (date: Date | null) => {
    const timestamp = date ? date.getTime() : Date.now()
    onChange(field.id, {
      fieldName: field.name,
      type: "datepicker",
      value: timestamp,
    })
  }

  return (
    <div className="w-1/2 p-4">
      <div>
        <Label>{field.label}</Label>
        <DateTimePicker
          value={currentValue ? new Date(currentValue) : null}
          onChange={handleChange}
          placeholder="Select date and time"
        />
      </div>
    </div>
  )
}

export default DatePicker
